/**
 * GiftListPresenter
 * --
 */
import React from 'react';

const GiftListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <div>
      <p>GiftListPresenter</p>
    </div>
  );
};

export default GiftListPresenter;
